import { render, staticRenderFns } from "./RapportCa_Client.vue?vue&type=template&id=4808da92&"
import script from "./RapportCa_Client.vue?vue&type=script&lang=js&"
export * from "./RapportCa_Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports